import React from 'react'
import { renderHeadshot } from '../../../pages/Reports/helpers/renderHeadshot.function'
import { getHeadshot } from '../../../shared/utilities/getHeadshot.function'
import { formatRelativeTime } from './relativeTime'

export default function LiveLeaderboardRow({
  row,
  nowTick,
  isNew,
  variant = 'anchor',
  streakCount = 1,
  runIndex = 1,
  groupTotalPoints = 0,
}) {
  const { agent, carrier, coverage, av_points, status, av_created } = row

  if (variant === 'continuation') {
    // Tier escalates with run length: ×2 = yellow (warm), ×3 = orange (hot),
    // ×4+ = red (on fire). Keeps a clear visual progression for streaks.
    const multiplierTier = runIndex >= 4 ? 'red' : runIndex === 3 ? 'orange' : 'yellow'

    return (
      <li className={`LiveLeaderboardRow LiveLeaderboardRow--continuation${isNew ? ' is-new' : ''}`}>
        <div className='LiveLeaderboardRow__multiplier-slot'>
          <span
            className={`LiveLeaderboardRow__multiplier LiveLeaderboardRow__multiplier--${multiplierTier}`}
            aria-label={`Sale ${runIndex} of agent run`}
          >
            ×{runIndex}
          </span>
        </div>
        <div className='LiveLeaderboardRow__body'>
          <div className='LiveLeaderboardRow__meta'>
            {carrier} · {coverage}
          </div>
          <div className='LiveLeaderboardRow__footer'>
            <span className={`status-pill status-pill--${status.toLowerCase()}`}>{status}</span>
            <span className='points'>{av_points.toLocaleString()} pts</span>
          </div>
        </div>
      </li>
    )
  }

  // Anchor: full row. When the anchor heads a multi-row group, the streak pill
  // is expanded from just "🔥" to "🔥 N pts total" — making the total explicit
  // up top — while the footer shows this specific row's per-policy points
  // (unchanged from the solo case). Continuations show their own per-policy.
  const agentPic = getHeadshot({ id: agent.id, u_picture: agent.u_picture })
  const isStreak = streakCount > 1

  return (
    <li
      className={`LiveLeaderboardRow LiveLeaderboardRow--anchor${isNew ? ' is-new' : ''}${
        isStreak ? ' is-streak' : ''
      }`}
    >
      <div className='LiveLeaderboardRow__headshot'>
        {renderHeadshot({
          agentPic,
          agentName: agent.name,
          agentId: agent.id,
          isConfQualified: agent.conf_qualifier,
        })}
      </div>
      <div className='LiveLeaderboardRow__body'>
        <div className='LiveLeaderboardRow__name-row'>
          <span className='LiveLeaderboardRow__name'>{agent.name}</span>
          {isStreak && (
            <span
              className='LiveLeaderboardRow__streak'
              title={`Group total: ${groupTotalPoints.toLocaleString()} pts across ${streakCount} policies`}
              aria-label={`Group total ${groupTotalPoints} points across ${streakCount} policies`}
            >
              <span aria-hidden='true'>🔥</span>
              <span className='LiveLeaderboardRow__streak-total'>{groupTotalPoints.toLocaleString()} pts</span>
            </span>
          )}
        </div>
        <div className='LiveLeaderboardRow__meta'>
          {carrier} · {coverage}
        </div>
        <div className='LiveLeaderboardRow__footer'>
          <span className={`status-pill status-pill--${status.toLowerCase()}`}>{status}</span>
          <span className='points'>{av_points.toLocaleString()} pts</span>
          <span className='time'>{formatRelativeTime(av_created, nowTick)}</span>
        </div>
      </div>
    </li>
  )
}
